import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ballotRoute, homeRoute, registrationRoute } from '../route-names';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { defaultSupportEmail } from '../app.component';
import { ApiAboutService } from '../Services/api-about.service';
import { SessionService } from '../Services/session.service';

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss'],
    standalone: false
})
export class WelcomeComponent implements OnInit, AfterViewInit {

  startTimeReadable: string = "";
  closeTimeReadable: string = "";
  registrationStartTimeReadable: string = "";
  registrationCloseTimeReadable: string = "";
  clientFAQ: string;

  supportEmail = defaultSupportEmail;
  constructor(private router: Router, 
    private sessionService: SessionService,
    readonly aboutService: ApiAboutService) {
      this.clientFAQ = environment.clientWebURL
  }

  isBrowserSupportModalOpen = new BehaviorSubject(false);
  readonly isAdminVersion = new BehaviorSubject(environment.pollingStation);
  adminVerificationRequired = new BehaviorSubject(environment.pollingStation);
  isCookiesEnabled = ("cookie" in document && (document.cookie.length > 0 ||
    (document.cookie = "test").indexOf.call(document.cookie, "test") > -1));

  ngOnInit(): void {
    this.checkBrowserSupport();
  }

//   getAdminStatus(): Boolean {
//     return localStorage.getItem("isAdminVerified") === 'true';
// }
  ngAfterViewInit(){
    setTimeout(()=>{  
      this.resetFocus()
    }, 100);    
  }

  resetFocus() {
    let focusField = document.getElementById('accessibility-button')
    let focusFieldMobile = document.getElementById('accessibility-button-mobile')
  
    if (focusField) {
      focusField.focus()
    }

    if (focusFieldMobile) {
     focusFieldMobile.focus()
    }
  }

  toHomeScreen(): void {
    if(!this.isCookiesEnabled) {
      this.isBrowserSupportModalOpen.next(true);
    } else if(this.isElectionLive()) {
      this.router.navigate(homeRoute);
    } else {
      return;
    }
  }

  toBallotScreen(): void {
    this.router.navigate(ballotRoute);
  }
  
  toRegistrationScreen(): void {
    if(!this.isCookiesEnabled) {
      this.isBrowserSupportModalOpen.next(true);
    } else if(this.isRegistrationLive()) {
      this.router.navigate(registrationRoute);
    } else {
      return;
    }
  }
 
  checkBrowserSupport() {
    if(!this.isCookiesEnabled) {
      this.isBrowserSupportModalOpen.next(true);
    }
    else {
      this.isBrowserSupportModalOpen.next(false);
    }
  }

  isElectionLive(): boolean {
    return !(this.aboutService.electionClosed || this.aboutService.electionNotYetOpen);
  }

  isRegistrationLive(): boolean {
    if(this.aboutService.hasRegistrationStep) {
      return !(this.aboutService.registrationClosed || this.aboutService.registrationNotYetOpen);
    } else {
      return false;
    }
  }

  isElectionNotOpenYet(): boolean {
    if(this.aboutService.electionNotYetOpen){
      this.startTimeReadable = this.aboutService.startTime;
      this.closeTimeReadable = this.aboutService.endTime;
    }
    return this.aboutService.electionNotYetOpen;
  }

  isElectionClosed(): boolean {
    if(this.aboutService.electionClosed) {
      this.startTimeReadable = this.aboutService.startTime;
      this.closeTimeReadable = this.aboutService.endTime;
    }
    return this.aboutService.electionClosed;
  }

  isRegistrationNotOpenYet(): boolean {
    if(this.aboutService.registrationNotYetOpen){
      this.registrationStartTimeReadable = this.aboutService.regStartTime;
      this.registrationCloseTimeReadable = this.aboutService.regEndTime;
      this.startTimeReadable = this.aboutService.startTime;
      this.closeTimeReadable = this.aboutService.endTime;
    }
    return this.aboutService.registrationNotYetOpen;
  }

  isRegistrationClosed(): boolean {
    if(this.aboutService.registrationClosed) {
      this.registrationStartTimeReadable = this.aboutService.regStartTime;
      this.registrationCloseTimeReadable = this.aboutService.regEndTime;
      this.startTimeReadable = this.aboutService.startTime;
      this.closeTimeReadable = this.aboutService.endTime;
    }
    return this.aboutService.registrationClosed;
  }

}
